import fileTextIcon from '../assets/icons/darkIcons/file-text.svg'
import informationIcon from '../assets/icons/darkIcons/information.png'
import usersIcon from '../assets/icons/darkIcons/users.svg'
import bookUserIcon from '../assets/icons/darkIcons/book-user.svg'

export const dataSettings = [
    {
        id: 1,
        title: "Templates",
        description: "Ajouter des templates de factures",
        icon: fileTextIcon
    }, 
    {
        id: 2,
        title: "Informations direction",
        description: "Ajouter des informations direction pour l'interface client",
        icon: informationIcon
    },
    {
        id: 3,
        title: "Recrutement",
        description: "Gérer les offres d'emploi.",
        icon: usersIcon
    },{
        id: 4,
        title: "Guide social",
        description: "Modifier les guides social. Version anglaise et française.",
        icon: bookUserIcon
    }
]